module.exports = __webpack_public_path__ + "static/img/task2.646bd3f8.png";